exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".restore-points .modal-header {\n  padding-bottom: 5px; }\n\n.restore-points .modal-body {\n  overflow: hidden; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/dataprotection/dataprotection-vcd/vapp-card/vapp-card.scss
// module id = iT/5
// module chunks = 0